"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDeckResult = exports.validatePresentationDate = exports.validateSlide = exports.validateBullet = void 0;
const validation_1 = require("@fmtk/validation");
const nullOptional_1 = require("../validation/nullOptional");
exports.validateBullet = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    popupImageUrl: (0, validation_1.optional)((0, validation_1.text)()),
    popupText: (0, validation_1.optional)((0, validation_1.text)()),
    text: (0, validation_1.optional)((0, validation_1.text)()),
    deleted: (0, validation_1.optional)((0, validation_1.bool)()),
});
exports.validateSlide = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    bullets: (0, validation_1.array)(exports.validateBullet),
    name: (0, validation_1.text)(),
    deleted: (0, validation_1.optional)((0, validation_1.bool)()),
});
exports.validatePresentationDate = (0, validation_1.properties)({
    date: (0, validation_1.text)(),
    dateType: (0, validation_1.integer)(),
    reminderOptIn: (0, validation_1.bool)(),
});
exports.validateDeckResult = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    created: (0, validation_1.integer)(),
    deleted: (0, validation_1.optional)((0, validation_1.bool)()),
    modified: (0, validation_1.integer)(),
    name: (0, validation_1.text)(),
    slides: (0, validation_1.array)((0, nullOptional_1.nullOptional)(exports.validateSlide)),
    presentationsStarted: (0, validation_1.optional)((0, validation_1.integer)()),
    presentationsCompleted: (0, validation_1.optional)((0, validation_1.integer)()),
    rehearsalsStarted: (0, validation_1.optional)((0, validation_1.integer)()),
    rehearsalsCompleted: (0, validation_1.optional)((0, validation_1.integer)()),
    presentationDate: (0, validation_1.optional)(exports.validatePresentationDate),
});
//# sourceMappingURL=DeckResult.js.map